export const THEME_KEY = 'crezia-theme';

export type Theme = 'light' | 'dark';

export function getTheme(): Theme {
  return document.documentElement.dataset.theme === 'light' ? 'light' : 'dark';
}

export function applyTheme(theme: Theme): void {
  document.documentElement.dataset.theme = theme;
  localStorage.setItem(THEME_KEY, theme);
  syncThemeToggle();
}

export function toggleTheme(): void {
  applyTheme(getTheme() === 'dark' ? 'light' : 'dark');
}

function syncThemeToggle(): void {
  const next = getTheme() === 'dark' ? 'Light' : 'Dark';
  document.querySelectorAll<HTMLButtonElement>('[data-theme-toggle]').forEach((btn) => {
    btn.textContent = next;
    btn.setAttribute('aria-label', `Switch to ${next.toLowerCase()} theme`);
  });
}

export function bindThemeToggles(): void {
  document.querySelectorAll('[data-theme-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => toggleTheme());
  });
  syncThemeToggle();
}
